import { Screen13 } from "../../../../src/components/images/support/xero/Screen13.generated";
import { Screen14 } from "../../../../src/components/images/support/xero/Screen14.generated";
import { Screen1 } from "../../../../src/components/images/support/xero/Screen1.generated";
import * as React from 'react';
export default {
  Screen13,
  Screen14,
  Screen1,
  React
};